module.exports = __webpack_public_path__ + "static/media/consensys.955b10ea.png";